
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/edit-company",
      function () {
        return require("private-next-pages/companies/edit-company.tsx");
      }
    ]);
  